import { ModalContainerService } from "@aecom/core";
import { Component, inject } from "@angular/core";
import { BBJFileListService } from "@bbj/components";
import CorrespondenceFileType from "@models/CorrespondenceFileType";
import CorrWithdrawStep from "@models/corrWithdrawStep";
import BaseFunctionService from "@services/baseFunction.service";

@Component({
  selector: "app-withdraw-modal",
  templateUrl: "./withdraw-modal.component.html",
  styleUrls: ["./withdraw-modal.component.scss"],
  standalone: false
})
export class WithdrawModalComponent {
  private activeModal = inject(ModalContainerService);
  baseFunctionService = inject(BaseFunctionService);
  bbjFileListService = inject(BBJFileListService);

  item: CorrWithdrawStep;

  attemptToIssue = false;

  notesMaxLength = 2000;

  set setItem(item: CorrWithdrawStep) {
    this.item = item;
    this.bbjFileListService.initItem([{files:[],title:CorrespondenceFileType.Attachment}]);
    this.baseFunctionService.setTempId(item.tempId);
  }

  get correspondenceFileType(): typeof CorrespondenceFileType {
    return CorrespondenceFileType;
  }
  
  save() {
    this.attemptToIssue = true;

    if (this.bbjFileListService.hasFilesUploading()) {
      this.bbjFileListService.showFileProgressNotification();
    } else if (this.isValid()) {
      this.bbjFileListService.updateFiles(this.item);
      this.activeModal.close(this.item);
    }
  }

  isValid(): boolean {
    return this.item.correspondence_withdraw.Notes && 
      this.item.correspondence_withdraw.Notes.length > 0 && 
      !this.baseFunctionService.isInputInvalid(this.item.correspondence_withdraw.Notes) &&
      this.getNotesLength() <= this.notesMaxLength;
  }

  cancel() {
    this.activeModal.close(null);
  }

  getNotesLength(): number {
    return this.item.correspondence_withdraw.Notes
      ? this.item.correspondence_withdraw.Notes.length
      : 0;
  }
}
